<template>
  <div class="pagination">
    <div class="container">
      <div
        :class="['pagination-left', { 'is-invisible' : !back }]"
      >
        <btn
          :theme="'ghost'"
          @click="$emit('prev')"
        >
          {{ prevLabel }}
        </btn>
      </div>

      <btn
        :disabled="nextDisable"
        @click="$emit('next')"
      >
        {{ nextLabel }}
      </btn>
    </div>
  </div>
</template>

<script>
import Btn from '@/components/components/Btn.vue';

export default {
  components: {
    Btn
  },
  props: {
    back: {
      type: Boolean,
      default: true
    },
    prevLabel: {
      type: String,
      default: 'Retour'
    },
    nextLabel: {
      type: String,
      default: 'Suivant'
    },
    nextDisable: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  @include position(fixed, null null 68px 0);
  @include padding(20px null);
  @include size(100%, auto);
  z-index: 24;
  border-top: 1px solid rgba($white, .1);
  background-color: $black-lighter;

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .btn {
    @include padding(15px null);

    &.cta {
      @include margin(null null null 20px);
      flex-grow: 1;
    }
  }

  &-left {
    &.is-invisible {
      opacity: 0;
      pointer-events: none;
    }
  }
}
</style>
